<template>
    <v-layout />
</template>

<script>
export default {
    name: 'MessageGroupCreate'
};
</script>
